import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";

import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton } from "components/ui";

import "./styles.css";
import "./mobile.css";


/**
 * @function NonNachaFileImportForm
 * @return {React.Component}
 * @exported true
 * @description The non nacha file form component for the NonNachaFileImportPage.
 */
export default function NonNachaFileImportForm(props) {
    const { ui, data, onChange, onChooseFile, onContinue, onCompanySelect } = useStateManager();
    // Company select items
    const companyItems = data.companys.reduce((acc, item) => {
        return [...acc, <CustomSelectItem dataPoint={ `Company_Select_Option_${ item.id }` } key={item.id} value={item}>{item.name} - {item.number}</CustomSelectItem>]
    }, [<CustomSelectItem dataPoint={ `Company_Select_Option_Prompt` } className="placeholder-item" key="chooseCompany" value="chooseCompany">Choose Company</CustomSelectItem>]);

    // Template select items
    const templateItems = data.templates.reduce((acc, item) => {
        return [ ...acc, <CustomSelectItem key={item.id} dataPoint={ `Choose_Template_Select_Option_${ item.id }` } value={item.value}>{item.value}</CustomSelectItem> ];
    }, [ <CustomSelectItem key={ `prompt` }  className="placeholder-item" dataPoint={ `Choose_Template_Select_Option_Prompt` } value={ `New Template` }>{ `New Template` }</CustomSelectItem> ])

    // Transactions Type select items
    const transactionTypeItems = data.transactionsType.reduce((acc, item) => {
        if (item.value === "PPD Credit - Consumer Credit") {
            return [...acc, <CustomSelectItem key={item.id} dataPoint={ `Transaction_Type_Select_Option_${ item.id }` } value={item.value}>{item.value}</CustomSelectItem>]
        } else {
            return [...acc, <DisabledPrompt key={item.id}><CustomSelectItem dataPoint={ `Transaction_Type_Select_Option_${ item.id }` } value={item.value}>{item.value}</CustomSelectItem></DisabledPrompt>]
        }
    }, [<CustomSelectItem dataPoint={ `Transaction_Type_Select_Option_Prompt` } className="placeholder-item" key="chooseTransactionType" value="chooseTransactionType">Choose Transaction Type</CustomSelectItem>]);

    // Chosen file name
    const fileName = ui.isFileChosen ? data.chosenFileName : "No file chosen";

    return (
        <FormContainer className="non-nacha-file-import-form small-form-width">
            <FormRowView text="Company">
                <CustomSelect dataPoint={ `Company_Select` } active={ ui.companySelect.isActive } value={data.selectedCompany} onChange={onCompanySelect("companyAccount")}>
                    {companyItems}
                </CustomSelect>
            </FormRowView>
            <FormRowView text="Choose Template">
                <CustomSelect dataPoint={ `Choose_Template_Select` } className={!ui.isCompanySelected ?"disabled" : ""} value={data.selectedTemplate} >
                    {templateItems}
                </CustomSelect>
            </FormRowView>
            <FormRowView text="Transaction Type">
                <CustomSelect active={ ui.transactionTypeSelect.isActive } value={data.selectedtransactionType} onChange={onChange("transactionType")}>
                    {transactionTypeItems}
                </CustomSelect>
            </FormRowView>
            <FormRowView text="File">
                <div className="flex-container flex-horizontal align-center choose-file-container">
                    <SecondaryButton dataPoint={ `Choose_File_Button` } text="Choose File" onClick={onChooseFile} />
                    <p className="set-width">{fileName}</p>
                </div>
            </FormRowView>
            <FormRowView>
                <p>Maximum file size: 3 MB</p>
                <p>Valid file extensions: .csv, .txt</p>
            </FormRowView>
            <FormButtonRow>
                <PrimaryButton dataPoint={ `Continue_Button` } className={`continue-button ${!ui.isFileChosen && "disabled-button"} `} text="Continue" onClick={onContinue} />
            </FormButtonRow>
        </FormContainer>
    )
}
